import Fetch from "../../components/fetch";

export default class MeditatedGospel {
	constructor() {
		this.api = new Fetch;
		this.setBaseUrl();
	}

	async getMeditatedGospel(date) {
		return await this.api.send(`meditated_gospel/${date}`);
	}

	setBaseUrl() {
		const url = `${window.location.origin}/wp-json/espiritualidade-parresia`
		this.api.setBaseUrl(url);
	}
}
